import { render, staticRenderFns } from "./IssuesView.vue?vue&type=template&id=338d8eae&"
import script from "./IssuesView.vue?vue&type=script&lang=js&"
export * from "./IssuesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports